export var VideosTab;
(function (VideosTab) {
    VideosTab[VideosTab["allVideos"] = 0] = "allVideos";
    VideosTab[VideosTab["purchased"] = 1] = "purchased";
})(VideosTab || (VideosTab = {}));
